// web/src/utils/labels/workflow-kb-state.ts —— 流程待办/实例状态与展示态
// 拆自 web/src/utils/labels.ts 的同名分区（内容原样搬运）；由 web/src/utils/labels.ts 以 export * 聚合，导出面对调用方不变。
// 注：原先还含知识库状态元数据，已随问答知识库整体下线删除（文件名保留历史前缀，分片内已无 KB 内容）。

import type { PillColor } from '../../components/PillTag';
/**
 * workflow 待办任务状态（task.state）→ [文案, 语义色]。
 * transferred/escalated 不是真实 state，是 pending + 转派/升级标记的展示覆盖值
 * （见 workflowTaskDisplayState）。待办中心列表、流程时间线、工单详情共用，同值同词同色。
 */
export const WORKFLOW_TASK_STATE_LABELS: Record<string, [string, PillColor]> = {
  pending: ['待处理', 'orange'],
  approved: ['已通过', 'green'],
  rejected: ['已驳回', 'red'],
  completed: ['已完成', 'green'],
  skipped: ['已跳过', 'gray'],
  transferred: ['已转派', 'arcoblue'],
  escalated: ['已升级', 'gold'],
};

/** workflow 审核流程实例状态（instance.state）→ [文案, 语义色] */
export const WORKFLOW_INSTANCE_STATE_LABELS: Record<string, [string, PillColor]> = {
  pending: ['审核中', 'orange'],
  finished: ['已通过', 'green'],
  rejected: ['已驳回', 'red'],
  cancelled: ['已取消', 'gray'],
};

/** 待办任务展示态：pending 且已转派/已升级 → transferred/escalated 覆盖值（列表与时间线同口径） */
export function workflowTaskDisplayState(t?: { state?: string | null; transferred_at?: string | null; escalated_at?: string | null }): string {
  if (!t) return '';
  if (t.state === 'pending' && t.transferred_at) return 'transferred';
  if (t.state === 'pending' && t.escalated_at) return 'escalated';
  return t.state || '';
}

/** 待办任务状态 [文案, PillColor]（未知值原样展示 + gray 兜底） */
export function workflowTaskStateMeta(v?: string): [string, PillColor] {
  const key = v || '';
  return WORKFLOW_TASK_STATE_LABELS[key] || [key || '-', 'gray'];
}

/** 流程实例状态 [文案, PillColor]（未知值原样展示 + gray 兜底） */
export function workflowInstanceStateMeta(v?: string): [string, PillColor] {
  const key = v || '';
  return WORKFLOW_INSTANCE_STATE_LABELS[key] || [key || '-', 'gray'];
}

